export default "__VITE_ASSET__DXTAZY5e__"